import React, { useCallback } from 'react';
import { TextInputWithAction } from '@/pageTpls/PlatformBuilder/subModules/TagsManagerV2/comps/TextInputWithAction';
import { useCreateTagV3 } from '@/utils/react-query-hooks/tags';

import { addTagToSelection, createTagWithAssociations } from '../utils/tagHelpers';
import { createDuplicateValidator } from '../utils/validators';

export const AddIndependentTagInput = ({ style, optionsDataTags = [], value, onChange, allTagsGlobal = [] }) => {
  const createTagV3 = useCreateTagV3();

  const validateInput = useCallback(
    createDuplicateValidator({ sourceList: optionsDataTags, enforceGlobal: true, globalSourceList: allTagsGlobal }),
    [optionsDataTags, allTagsGlobal]
  );

  const addToSelection = useCallback((createdTagDoc) => {
    addTagToSelection(createdTagDoc, value, onChange);
  }, [onChange, value]);

  const handleAction = useCallback(async (text) => {
    const created = await createTagWithAssociations(createTagV3.mutate, { display: text });
    addToSelection(created);
  }, [createTagV3, addToSelection]);

  return (
    <div style={style} onMouseDown={(e) => { e.stopPropagation(); }}>
      <TextInputWithAction
        placeholder={"Add independent tag"}
        onAction={handleAction}
        validateInput={validateInput}
        actionButtonIcon={createTagV3.isLoading ? "Loader" : "Plus"}
        disabled={createTagV3.isLoading}
        clearOnAction
      />
    </div>
  );
};


